<template #default>
  <div class="page-view">
    <a-card class="page-filter" :bordered="false">
      <a-form layout="inline" @submit.prevent="onSearch">
        <a-form-item label="Book Code">
          <a-input
            v-model:value="bookCode"
            placeholder="Enter book code..."
            @pressEnter="onSearch"
          />
        </a-form-item>
        <a-form-item label="Fund">
          <a-select
            v-model:value="selectedFundId"
            style="width: 300px"
            allow-clear
            placeholder="All"
            :show-search="true"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in fundList"
              :key="item.fundCode"
              :value="item.fundId"
            >
              {{ item.fundCode }} - {{ item.fundDesc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <div class="page-actions">
            <a-button type="primary" @click="onSearch" :loading="loading"
              >Search</a-button
            >
            <a-button @click="showAddModal">Add</a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-card>

    <div class="page-grid page-grid--h360">
      <AgGridVue
        style="width: 100%; height: 100%"
        :theme="themeBalham"
        :loading="loading"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="rowData"
        :masterDetail="true"
        :detailCellRendererParams="detailCellRendererParams"
      />
    </div>

    <!-- Add/Edit Book Modal -->
    <a-modal
      class="page-modal"
      v-model:visible="addModalVisible"
      :title="isEdit ? 'Edit Book' : 'Add Book'"
      @ok="isEdit ? handleEditBook() : handleAddBook()"
      @cancel="handleAddCancel"
      :confirmLoading="addLoading"
      destroyOnClose
    >
      <a-form
        :model="addForm"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 17 }"
        layout="horizontal"
      >
        <a-form-item label="Book Code" required>
          <a-input
            v-model:value="addForm.bookCode"
            placeholder="T100"
            :disabled="isEdit"
          />
        </a-form-item>
        <a-form-item label="Book Desc" required>
          <a-input v-model:value="addForm.bookDesc" placeholder="T100" />
        </a-form-item>
        <a-form-item label="Fund" required>
          <a-select
            v-if="isEdit"
            v-model:value="addForm.fundId"
            placeholder="Selct fund"
            allow-clear
            show-search
            :filter-option="filterOption"
            :disabled="isEdit"
          >
            <a-select-option
              v-for="item in allFundList"
              :key="item.fundCode"
              :value="item.fundId"
            >
              {{ item.fundCode }} - {{ item.fundDesc }}
            </a-select-option>
          </a-select>
          <a-select
            v-else
            v-model:value="addForm.fundId"
            allow-clear
            show-search
            placeholder="Selct fund"
            :filter-option="filterOption"
            :disabled="isEdit"
          >
            <a-select-option
              v-for="item in fundList"
              :key="item.fundCode"
              :value="item.fundId"
            >
              {{ item.fundCode }} - {{ item.fundDesc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <!--  <a-form-item label="ManagedBy" required>
          <a-select
            v-model:value="addForm.managerId"
            placeholder="Select manager"
            :show-search="true"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in isEdit ? userAccountList : activeUserAccountList"
              :key="item.userAccountName"
              :value="item.userAccountId"
            >
              {{ item.userAccountName }} - {{ item.role }} -
              {{ item.isActive ? 'Active' : 'Inactive' }}
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="Is Platform">
          <a-switch v-model:checked="addForm.isPlatform" />
        </a-form-item>
        <a-form-item
          label="Generate BU"
          :wrapper-col="{ span: 24, offset: 0 }"
          v-if="!isEdit"
        >
          <div style="display: flex; align-items: center">
            <a-switch v-model:checked="addForm.needGenerateBU" />
            <a-input
              v-model:value="addForm.buCode"
              style="margin-left: 16px; width: 200px"
              placeholder="T100"
            />
          </div>
        </a-form-item>
        <a-form-item label="Strategy">
          <a-select
            v-model:value="addForm.strategy"
            placeholder="Select strategy"
            :options="strategyList.map((item) => ({ value: item }))"
            :show-search="true"
          >
            <!-- <a-select-option
              v-for="item in strategyList"
              :key="item.code"
              :value="item.desc"
            >
              {{ item.code }} - {{ item.desc }}
            </a-select-option> -->
            <template #dropdownRender="{ menuNode: menu }">
              <v-nodes :vnodes="menu" />
              <a-divider style="margin: 4px 0" />
              <a-space style="padding: 4px 8px">
                <a-input
                  ref="inputRef"
                  v-model:value="name"
                  placeholder="Please enter item"
                />
                <a-button type="text" @click="addItem">
                  <template #icon>
                    <plus-outlined />
                  </template>
                  Add item
                </a-button>
              </a-space>
            </template>
          </a-select>
        </a-form-item>
        <a-form-item label="Location">
          <a-select
            v-model:value="addForm.location"
            placeholder="Select location"
            :show-search="true"
            :allow-clear="true"
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in locationList"
              :key="item.code"
              :value="item.desc"
            >
              {{ item.code }} - {{ item.desc }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="EnableTxnStrategy">
          <a-switch v-model:checked="addForm.enableTxnStrategy" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, computed, defineExpose, defineComponent, watch } from 'vue'
import { useStore } from 'vuex'
import { themeBalham } from 'ag-grid-community'

import { message } from 'ant-design-vue'
import { PlusOutlined } from '@ant-design/icons-vue'

import {
  bookViewColumnDefs,
  detailColumnDefs,
} from '@/views/reference/book/BookView_ColumnDefs'
import AgEditCellRenderer from '@/components/AgEditCellRenderer.vue'
import book from '@/api/book'

const store = useStore()

const defaultColDef = {
  filter: true,
  sortable: true,
  resizable: true,
}

const columnDefs = bookViewColumnDefs.map((col) => {
  if (col.field === 'edit') {
    return {
      ...col,
      cellRendererParams: {
        showEditModal: (data) => showEditModal(data),
      },
    }
  }
  return col
})

const detailCellRendererParams = {
  detailGridOptions: {
    columnDefs: detailColumnDefs,
  },
  getDetailRowData: async (params) => {
    const resp = await book.getBuBooks(params.data.fundBookId)
    if (resp.data && Array.isArray(resp.data)) {
      params.successCallback(resp.data)
    } else {
      params.successCallback([])
    }
  },
}

defineExpose({
  AgEditCellRenderer,
})

const VNodes = defineComponent({
  props: {
    vnodes: {
      type: Object,
      required: true,
    },
  },
  render() {
    return this.vnodes
  },
})

/* const userAccountList = computed(() => {
  const userList = store.getters['reference/getUserAccountList'] || []
  // Sort: active first, then inactive
  return [...userList].sort((a, b) =>
    b.isActive === a.isActive ? 0 : b.isActive ? 1 : -1
  )
})

const activeUserAccountList = computed(() => {
  const userList = store.getters['reference/getUserAccountList'] || []
  return [...userList]
    .filter((u) => u.isActive)
    .sort((a, b) => a.userAccountName.localeCompare(b.userAccountName))
}) */

const fundList = computed(() => {
  const funds = store.getters['reference/getFundList'] || []
  return [...funds]
    .filter((f) => f.isActive && f.isReal)
    .sort((a, b) => a.fundCode.localeCompare(b.fundCode))
})

const allFundList = computed(() => {
  const funds = store.getters['reference/getFundList'] || []
  return [...funds].sort((a, b) => a.fundCode.localeCompare(b.fundCode))
})
const locationList = [
  {
    code: 'HK',
    desc: 'Hong Kong',
  },
  {
    code: 'IN',
    desc: 'India',
  },
  {
    code: 'JP',
    desc: 'Japan',
  },
  {
    code: 'SG',
    desc: 'Singapore',
  },
  {
    code: 'SH',
    desc: 'Shanghai',
  },
]

const selectedFundId = ref(undefined)
const bookCode = ref('')
const loading = ref(false)
const rowData = ref([])
const inputRef = ref()
const name = ref()
const strategyList = ref([
  'ARB',
  'CB',
  'CREDIT',
  'CTA',
  'EQUITY',
  'EVENT',
  'MACRO',
  'NICK',
  'QUANT',
  'QUANT_CTA',
  'QUANT_TEC',
  'VOL',
  'VOLARB',
])

const addItem = (e) => {
  e.preventDefault()
  strategyList.value.push(name.value)
  name.value = ''
  setTimeout(() => {
    inputRef.value?.focus()
  }, 0)
}

const onSearch = async () => {
  loading.value = true
  try {
    const qry = {
      bookCode: bookCode.value.trim(),
      fundId: selectedFundId.value,
    }
    const resp = await book.getBookList(qry)
    const data = resp.data
    rowData.value = Array.isArray(data) ? data : []
    if (rowData.value.length === 0) {
      message.info('No data found.')
    }
  } catch (e) {
    const messageText = e?.response?.data?.message || 'Query failed'
    message.error(messageText)
  } finally {
    loading.value = false
  }
}

const addModalVisible = ref(false)
const addLoading = ref(false)
const createAddForm = () => ({
  bookCode: '',
  bookDesc: '',
  fundId: undefined,
  managerName: '',
  isPlatform: true,
  needGenerateBU: false,
  buCode: '',
  strategy: 'EQUITY',
  location: '',
  enableTxnStrategy: false,
})
const addForm = ref(createAddForm())
const isEdit = ref(false)

watch(
  () => addForm.value.bookCode,
  (val) => {
    if (val && val !== val.toUpperCase()) {
      const normalized = val.toUpperCase()
      addForm.value.bookCode = normalized
      addForm.value.buCode = normalized
    }
  }
)

const showAddModal = () => {
  isEdit.value = false
  addForm.value = createAddForm()
  addModalVisible.value = true
}

function showEditModal(event) {
  const data = event?.data || event
  isEdit.value = true
  addForm.value = data
  addModalVisible.value = true
}

const filterOption = (input, option) => {
  return String(option?.key || '')
    .toLowerCase()
    .includes(String(input || '').toLowerCase())
}

const handleAddCancel = () => {
  addModalVisible.value = false
}

const handleAddBook = async () => {
  addLoading.value = true
  try {
    if (
      !addForm.value.bookCode ||
      !addForm.value.bookDesc ||
      !addForm.value.fundId ||
      // !addForm.value.managerId ||
      !addForm.value.strategy
    ) {
      message.warning('Please fill all required fields.')
      addLoading.value = false
      return
    }
    await book.createBook({ ...addForm.value })
    message.success('Add success')
    addModalVisible.value = false
    onSearch()
  } catch (e) {
    const messageText = e?.response?.data?.message || 'Add failed'
    message.error(messageText)
  } finally {
    addLoading.value = false
  }
}

const handleEditBook = async () => {
  addLoading.value = true
  try {
    if (
      !addForm.value.bookCode ||
      !addForm.value.bookDesc ||
      !addForm.value.fundId
      // !addForm.value.managerId
    ) {
      message.warning('Please fill all required fields.')
      addLoading.value = false
      return
    }
    await book.updateBook({ ...addForm.value })
    message.success('Edit success')
    addModalVisible.value = false
    onSearch()
  } catch (e) {
    const messageText = e?.response?.data?.message || 'Edit failed'
    message.error(messageText)
  } finally {
    addLoading.value = false
  }
}
</script>
